export default __webpack_public_path__ + "static/media/banner-login.bfba46ae.jpg";